define('views/lib/Podio.Views.AccountsSettingsDropdown',['require','translate','underscore','jquery','lib/backbone/Backbone.PodioView','lib/Podio.UI.SettingsBalloon','lib/Podio.Utils','jst!filefinder/_settings_dropdown'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var settingsBalloon = require('lib/Podio.UI.SettingsBalloon');
  var podioUtils = require('lib/Podio.Utils');

  var jstSettingsDropdown = require('jst!filefinder/_settings_dropdown');

  return ViewPodioBase.extend({
    podioEvents : {
      'click .settings-connect-button'     : 'onConnectButtonClick',
      'click ul li '                       : 'onAccountClick',
      'click .settings-permissions-button' : 'onChangePermissionSettingsButtonClick'
    },

    initialize : function(options) {

      _.bindAll(this, 'render', 'onConnectButtonClick');

      this._super();

      this.elm = $(this.el);
      this.currentLinkedAccountId = options.currentLinkedAccountId || 0;

      this.accounts = options.accounts;
      this.account = options.account;
      this.providerName = this.account.get('provider') || this.account.get('name');
      if (this.options.capability) {
        this.providerHumanizedName = this.account.get('capability_names')[this.options.capability];
      }
      else {
        this.providerHumanizedName = this.account.get('provider_humanized_name') || this.account.get('humanized_name');
      }

      this.state = options.state;

      if (this.state) {
        this.state.bind('change', this.render);
      }

      this.showPermissionSettings = options.showPermissionSettings;
      this.preservePermissions = options.preservePermissions;
    },

    render : function() {
      if (this.state) {
        this.currentLinkedAccountId = this.state.get( '{0}_linked_account_id'.format(this.providerName));
      }

      this.elm.empty();

      var permissionsText;

      if (this.preservePermissions === null) {
        permissionsText = t('Sharing a document requires your permission #filefinder');
      } else if (this.preservePermissions) {
        permissionsText = t('Sharing a document will not change permissions #filefinder');
      } else {
        permissionsText = t('Sharing a document makes it available to anyone with the link #filefinder');
      }

      this.elmOptions = $(this.getTemplate(jstSettingsDropdown, {
        accounts                : this.accounts,
        state                   : this.state,
        currentLinkedAccountId  : this.currentLinkedAccountId,
        providerName            : this.providerName,
        connectButtonText       : t('Connect to {0} #filefinder').format( this.providerHumanizedName ),
        showPermissionSettings  : this.showPermissionSettings,
        permissionsText         : permissionsText
      }));

      this.elm.html(this.elmOptions);

      return this;
    },

    dispose: function() {
      this.remove();
    },

    onConnectButtonClick : function(elmTarget, e) {
      settingsBalloon.hideAll();

      this.trigger('connectService', this.providerName);
      this.trigger('accountsSettingsDropdown:connectTriggered', this.providerName);
    },

    onAccountClick: function(elmTarget, e) {
      e.stopPropagation();

      settingsBalloon.hideAll();
      this.trigger('changeAccount', this.providerName, $(e.currentTarget).data('linked-account-id'));
      this.trigger('accountsSettingsDropdown:accountChanged', this.providerName, $(e.currentTarget).data('linked-account-id'));
    },

    onChangePermissionSettingsButtonClick : function(elmTarget, e) {
      settingsBalloon.hideAll();
      this.trigger('changePermissionSettings', this.account);
    }

  });


});

